import { render } from "./CCSMockUp.vue?vue&type=template&id=6f8faaf2"
import script from "./CCSMockUp.vue?vue&type=script&lang=js"
export * from "./CCSMockUp.vue?vue&type=script&lang=js"

import "./CCSMockUp.vue?vue&type=style&index=0&id=6f8faaf2&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__